import { Observable } from 'rxjs/Rx';
import { Injectable } from '@angular/core';
import { Response, ResponseContentType, RequestOptions, URLSearchParams } from '@angular/http';

import { AuthHttp, QueryEncoderHelper } from 'app/infrastructure/common';
import { AppSettings } from 'app/infrastructure/settings';

@Injectable()
export class AnnouncementService {
    constructor(private http: AuthHttp) { }

    getNewAnnouncement() {
        let params: URLSearchParams = new URLSearchParams();

        let options: RequestOptions = new RequestOptions({ search: params });

        return this.http.get(AppSettings.apiEndpoint + 'Announcement/GetNewAnnouncement', options)
            .map((response: Response) => response.json());
    }

    getAnnouncementById(id: number) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('id', id.toString());
        let options: RequestOptions = new RequestOptions({ search: params });

        return this.http.get(AppSettings.apiEndpoint + 'Announcement/GetAnnouncementById', options)
            .map((response: Response) => response.json());
    }

    getAnnouncementListByFilter(searchParams: any[]) {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in searchParams) {
            let value = undefined;
            if (searchParams[key] && searchParams[key] instanceof Date) {
                value = searchParams[key].toUTCString();
            } else {
                value = searchParams[key];
            }
            params.set(key, value);
        }
        let options: RequestOptions = new RequestOptions({ search: params });

        return this.http.get(AppSettings.apiEndpoint + 'Announcement/GetAnnouncementListByFilter', options)
            .map((response: Response) => response.json());
    }

    GetActiveAnnouncementList(ownerCode: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('ownerCode', ownerCode);

        let options: RequestOptions = new RequestOptions({ search: params });

        return this.http.get(AppSettings.apiEndpoint + 'Announcement/GetActiveAnnouncementList', options)
            .map((response: Response) => response.json());
    }

    checkExistingAnnouncementByCode(code: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('code', code);
        let options: RequestOptions = new RequestOptions({ search: params });

        return this.http.get(AppSettings.apiEndpoint + 'Announcement/CheckExistingAnnouncementByCode', options)
            .map((response: Response) => response.json());
    }

    saveAnnouncement(announcement: any) {
        return this.http.post(AppSettings.apiEndpoint + 'Announcement/SaveAnnouncement', announcement)
            .map((response: Response) => response.json());
    }

    deleteAnnouncement(id: number) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('id', id.toString());

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.delete(AppSettings.apiEndpoint + 'Announcement/DeleteAnnouncement', options)
            .map((response: Response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/infrastructure/services/transaction/op/announcement/announcement.service.ts